<template>
  <div id="app">
    <!-- Componentes del sitio principal (solo para páginas públicas) -->
    <NavComponent v-if="!isAdminRoute" />
    <router-view />
    <WhatsappFloatComponent v-if="!isAdminRoute" msg="" phone="+8298073310" />
    <FooterComponent v-if="!isAdminRoute" />
  </div>
</template>

<script>
import './assets/css/styles.scss';
import NavComponent from './components/Nav-component.vue';
import FooterComponent from './components/Footer-component.vue';
import WhatsappFloatComponent from './components/WhatsappFloat-component.vue';

export default {
  name: 'App',
  components: {
    NavComponent,
    FooterComponent,
    WhatsappFloatComponent
  },
  computed: {
    isAdminRoute() {
      // Rutas que NO deben mostrar header/footer del sitio principal
      const adminRoutes = ['/login', '/dashboard'];
      return adminRoutes.some(route => this.$route.path.startsWith(route));
    }
  }
}
</script>